/* registericons.js */

"use strict";
const IconRegistry = require("@gluenetworks/icon_registry").getInstance();

IconRegistry.registerIcon("worktrigger.pause", require("./rawicons/pause.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.run", require("./rawicons/run.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.history", require("./rawicons/history.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.future", require("./rawicons/future.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.edit", require("./rawicons/edit.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.first", require("./rawicons/first.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.last", require("./rawicons/last.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.only", require("./rawicons/only.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.once", require("./rawicons/once.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.repeat", require("./rawicons/repeat.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.manual", require("./rawicons/manual.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.missed", require("./rawicons/missed.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.scheduled", require("./rawicons/scheduled.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.schedule", require("./rawicons/schedule.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.explorer", require("./rawicons/explorer.icon.svg.js"));
IconRegistry.registerIcon("worktrigger.overlapped", require("./rawicons/overlapped.icon.svg.js"));
